module.exports = __webpack_public_path__ + "static/media/test15_4.40b6698b.png";